// removed by extract-text-webpack-plugin
module.exports = {"text":"_224-00y-PmpTTOLtJbkxoo","textActive":"_3vj4uRZB0b9EcjEEsk9aGq","textHover":"XujP4jcHQulFZ7gKpM_Lg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons/Text/index.css
// module id = 678
// module chunks = 0